import { VariableProvider } from '../../components/FinanceEngine/context/VariableContext';
import { ConceptsProvider } from '../../components/FinanceEngine/context/ConceptsContext';
import { Plan } from '../../components/FinanceEngine/Plan';
import { MRRConceptsProvider } from '../../components/FinanceEngine/context/MRRConceptsContext';

const PlanScreen = () => (
    <ConceptsProvider>
        <MRRConceptsProvider>
            <VariableProvider>
                <Plan />
            </VariableProvider>
        </MRRConceptsProvider>
    </ConceptsProvider>
);
export { PlanScreen };
